@borderRadius: 4px;

.wrapper {
  display: flex;
  flex-flow: row;
}

.button-styles {
  flex-basis: fit-content;
  display: flex;
  justify-content: center;
  width: 100%;
}

.button-with-dropdown {
  border-radius: @borderRadius 0 0 @borderRadius;
  border-right: none;
}

.drop-down-menu-button {
  border-radius: 0 @borderRadius @borderRadius 0;
  padding: 0;
}

.dropdown-menu {
  max-width: none;
}

.button-label {
  display: flex;
  height: 28px;
}
